import botIcon from "../assests/images/bot-dp-1.png";
import "../styles/InterviewConversation.css";

function TranscriptNew({ conversations }) {
  // Helper function to generate user initials
  const getUserInitials = (name) => {
    return name
      ?.split(" ")
      ?.map((word) => word.charAt(0).toUpperCase())
      ?.join("") || "U";
  };

  // Render bot message component
  const renderBotMessage = (conversation, index) => (
    <div
      key={index}
      className="conversation-transcript-bot-chat-container"
      role="article"
      aria-label={`Bot message from ${conversation.speaker}`}
    >
      <div className="h-[35px] w-[40px] m-1">
        <img
          className="conversation-transcript-bot-chat-profile-image"
          alt="Bot avatar"
          src={botIcon}
        />
      </div>
      <div className="conversation-transcript-bot-chat-text-container">
        <div className="conversation-transcript-bot-chat-text-bot-name-and-time-container">
          <div className="font-medium text-sm text-white">
            {conversation.speaker}
          </div>
          <time className="font-light text-xs text-white">
            {conversation.time}
          </time>
        </div>
        <div className="text-sm text-white font-light">
          {conversation.message}
        </div>
      </div>
    </div>
  );

  // Render candidate message component
  const renderCandidateMessage = (conversation, index) => (
    <div
      key={index}
      className="conversation-transcript-candidate-chat-container"
      role="article"
      aria-label={`Candidate message from ${conversation.speaker}`}
    >
      <div 
        className="h-[35px] w-[40px] m-1 bg-app-secondary rounded-full text-white text-xs tracking-wider font-medium flex items-center justify-center"
        aria-label={`${conversation.speaker} avatar`}
      >
        {getUserInitials(conversation.speaker)}
      </div>
      <div className="conversation-transcript-candidate-chat-text-container">
        <div className="conversation-transcript-candidate-chat-text-candidate-name-and-time-container">
          <div className="font-medium text-sm text-white">
            {conversation.speaker}
          </div>
          <time className="font-light text-xs text-white">
            {conversation.time}
          </time>
        </div>
        <div className="text-sm text-white font-light">
          {conversation.message}
        </div>
      </div>
    </div>
  );

  return (
    <div 
      className="conversation-transcript-chat-container"
      role="log"
      aria-label="Interview conversation transcript"
    >
      {conversations.map((conversation, index) =>
        conversation.isBot
          ? renderBotMessage(conversation, index)
          : renderCandidateMessage(conversation, index)
      )}
    </div>
  );
}

export default TranscriptNew;
